/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-03-25 21:28:09
 */

 import * as Vue from 'vue-tsx-support';
 import { Component, Prop } from 'vue-property-decorator';
 import 'vue-tsx-support/enable-check';
 import Modal from 'src/types/iview/Modal';
 import Button from 'src/types/iview/Button';
 import Input from 'src/types/iview/Input';
 import { Toast } from 'src/util/toast';
 import { modalFactory } from 'src/util/vueExtend';
 import EnumOperates from 'src/enums/enumOperates';
 import { Integer, IViewDate } from 'src/types/base';
 import EntitySelect from 'src/components/SelectCustom/entitySelect';
 import EnumEntity from 'src/enums/enumEntity';
 import DatePicker from 'src/types/iview/DatePicker';
 import TestApi, {TestDOI} from '../api/testApi';
 import Upload from 'src/types/iview/Upload';
 import { createNamespace } from 'src/util/bem';
 import { DateTimeUtil } from 'src/util/dateTimeUtil';
 import { LoginDOI } from 'src/pages/login/loginApi';
 import LocalStore from 'src/util/LocalStore';
 
 export namespace ErroeFileAddVOI {
     export interface PropsI {
         id: number;
 
         saveSuccess?(): void;
 
         cancel?(): void;
     }
 
     export interface FormDataI {
         error_no_id: Integer;
         file_name: string;
         file_url: string;
     }
 }
 
 @Component
 class ErroeFileAddModel extends Vue.Component<ErroeFileAddVOI.PropsI> {
     @Prop({
         type: Function,
     })
     cancel!: () => void;
 
     @Prop({
         type: Number,
     })
     id: number;
 
     @Prop({
         type: Function,
     })
     saveSuccess!: () => void;
 
     visible: boolean = false;
 
     loading: boolean = false;
 
     uploading: boolean = false;
 
     formData: ErroeFileAddVOI.FormDataI = {
        error_no_id: null,
        file_name: '',
        file_url: '',
     };
     rules: any = {};
 
     get headers() {
         let headers:any = {}
         let userInfo: LoginDOI.LoginResultI = LocalStore.getData('userInfo');
         headers.access_token = userInfo.access_token || '';
         headers.OperationPlatform = 'Web';
         return headers
     }
 
     close() {
         this.cancel && this.cancel();
         this.closeModal();
     }
 
     closeModal() {
         this.visible = false;
         this.$emit('close', false);
     }
     uploadSuccess(res) {
         Toast.success(res.message)
         this.uploading = false;
         if(res.code===0) {
            this.formData.file_url=res.data.url
            this.formData.file_name = res.data.name
         } 
     }
     async save() {
         let res;
         this.loading = true;
         this.formData.error_no_id = this.id;
         debugger
         let params:TestDOI.AddErrorFile = {
            ...this.formData,
         };
         if (params.file_url == ""){
            return
         }
         res = await TestApi.add_error_file(params);
         this.loading = false;
         let { code } = res;
         if (code === 0) {
            Toast.success('添加成功');
            this.saveSuccess();
            this.closeModal();
            params.file_url =""
        }
     }
 
     render(h) {
         return (
             <Modal title={"文件上传"} width="800" v-model={this.visible} mask-closable={false} on-on-cancel={this.close}>
                 <i-form ref="formValidate" labelWidth={120} model={this.formData} rules={this.rules}>
                     <form-item label="上传附件"  style="display: inline-block;width:90%">
                         <Upload
                             class="lims-file-upload"
                             action="/ops/error_info_file/upload"
                             show-upload-list={false}
                             name="accessory"
                             headers={this.headers}
                             on-success={this.uploadSuccess}
                             before-upload={() => {
                                this.uploading = true;
                             }}
                         >
                                <Button class={createNamespace('upload-btn')} icon="ios-cloud-upload-outline" loading={this.uploading}>上传附件</Button>
                         </Upload>
                         <div class={createNamespace('upload-text')}>支持扩展名：.rar .zip .doc .docx .pdf .jpg</div>
                     </form-item>
                 </i-form>
                 <div slot="footer">
                     <Button type="primary" ghost on-click={this.close}>
                         取消
                     </Button>
                     <Button type="primary" on-click={this.save} loading={this.loading}>
                         保存
                     </Button>
                 </div>
             </Modal>
         );
     }
 }
 
 export default function alertErroeFileAddModel(id: number): Promise<boolean> {
     return new Promise((resolve, reject) => {
         modalFactory<ErroeFileAddVOI.PropsI>(ErroeFileAddModel)({
             id,
             saveSuccess() {
                resolve(true);
             },
             cancel() {
                 resolve(false);
             },
         });
     });
 }
 